import React from 'react';
import { UrgencyBar, HeroSection, PainRecognition } from '../components/sections/HeroSections';
import { AgitationSection, MechanismSection } from '../components/sections/ProblemSections';
import { ProductPresentation, TomosSection, ResultsSection } from '../components/sections/SolutionSections';
import { BonusesSection, PricingCTA } from '../components/sections/OfferSections';
import { TestimonialsSection, GuaranteeSection, FAQSection, FinalCTA, Footer } from '../components/sections/TrustSections';
export default function LandingPage() {
  return <div className="min-h-screen bg-cream font-body text-brown-text selection:bg-pink-primary selection:text-white" data-id="element-273">
      <UrgencyBar data-id="element-274" />

      <main data-id="element-275">
        <HeroSection data-id="element-276" />
        <PainRecognition data-id="element-277" />
        <AgitationSection data-id="element-278" />
        <MechanismSection data-id="element-279" />
        <ProductPresentation data-id="element-280" />
        <TomosSection data-id="element-281" />
        <ResultsSection data-id="element-282" />
        <BonusesSection data-id="element-283" />
        <PricingCTA data-id="element-284" />
        <TestimonialsSection data-id="element-285" />
        <GuaranteeSection data-id="element-286" />
        <FAQSection data-id="element-287" />
        <FinalCTA data-id="element-288" />
      </main>

      <Footer data-id="element-289" />
    </div>;
}